export default __webpack_public_path__ + "media/images/brands/jamie-oliver-fc3c47e969e6c8f161b833882b4221f4.png";